import React, { useState } from 'react';
import { Form, Input, Button, Typography, Alert } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { ReactComponent as Logo } from '../../images/pxlplygrnd-logo.svg';
import './Login.css';

const { Text, Link } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, loginWithGoogle } = useAuth();
  const theme = useTheme();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const from = location.state?.from?.pathname || '/dashboard';

  const onFinish = async (values) => {
    try {
      setError('');
      setLoading(true);
      await login(values.email, values.password);
      navigate(from, { replace: true });
    } catch (err) {
      setError('Failed to sign in. Please check your credentials.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      setError('');
      setLoading(true);
      await loginWithGoogle();
      navigate(from, { replace: true });
    } catch (err) {
      setError('Failed to sign in with Google.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container" style={{ background: theme.colors.bgBase }}>
      <div className="login-card" style={{
        background: theme.colors.bgSurface,
        border: `1px solid ${theme.colors.border}`
      }}>
        {/* Logo */}
        <div className="login-logo-container">
          <Logo className="login-logo" />
        </div>

        {/* Form */}
        <div className="login-form-container">
          {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 24 }} />}

          <Form
            name="login"
            onFinish={onFinish}
            layout="vertical"
            requiredMark={false}
          >
            <Form.Item
              name="email"
              rules={[{ required: true, message: 'Email is required' }]}
            >
              <Input
                placeholder="Email"
                size="large"
                className="login-input"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Password is required' }]}
              style={{ marginBottom: 24 }}
            >
              <Input.Password
                placeholder="Password"
                size="large"
                className="login-input"
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                loading={loading}
                className="login-button"
              >
                Sign in
              </Button>
            </Form.Item>
          </Form>

          <div className="login-footer">
            <Text style={{ color: theme.colors.textSecondary }}>
              Don't have an account? <Link style={{ color: theme.colors.primary }}>Sign up</Link>
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
